import { MonthlyOutgoingReport, ReportTransaction } from './YearlyOutgoingReportComponent';
import { asDate, asGbp } from './MobileFriendly';
import { RuleCategoryDefinition, UpdateTransactionMetadataRequest } from '../api/TransactionApi';
import { Button, Checkbox, Form, Input, Radio, Select } from 'antd';
import { useState } from 'react';

function addNewMatch(rules: RuleCategoryDefinition[], category: string, matchName: string): RuleCategoryDefinition | null {
    const ruleDefinition = rules.find(c => c.category === category)
    if (!ruleDefinition) {
        console.log('could not find rule definition')
        return null
    }

    const match = ruleDefinition.matches.find(c => c.name === matchName)
    if (!!match) {
        console.log('already exists')
        return null
    }

    ruleDefinition.matches.push({
        name: matchName,
    })

    return ruleDefinition
}

export const UnknownCategoriser = (props: {
    monthlyBreakdown: { [mm: string]: MonthlyOutgoingReport },
    rules: RuleCategoryDefinition[],
    updateMetadata: (request: UpdateTransactionMetadataRequest) => void,
    updateRule: (rule: RuleCategoryDefinition, existingCategoryName?: string) => void,
}) => {
    const categories = props.rules.map(r => r.category);
    const types = ['single', 'rule']
    const [selectedType, setSelectedType] = useState(types[0])

    const remainingTransactions = Object.keys(props.monthlyBreakdown)
        .sort()
        .reduce((acc, mm) => {
            const remaining = props.monthlyBreakdown[mm].report.remaining || [];
            return [...acc, ...remaining.map(r => ({ ...r, month: mm }))];
        }, [] as (ReportTransaction & { month: string })[])

    const nextTransactions = [remainingTransactions[0]];

    return <>
        {remainingTransactions.length > 0 && <>
            <div>{remainingTransactions.length} remaining transactions</div>
            {nextTransactions.map(nextTransaction => <div key={nextTransaction.id}>
                <div>{asDate(nextTransaction.timestamp)}</div>
                <div>{nextTransaction.description}</div>
                <div>{asGbp(nextTransaction.amount)}</div>

                <Radio.Group
                    options={types}
                    value={selectedType}
                    onChange={category => setSelectedType(category.target.value)}
                    optionType="button"
                    buttonStyle="solid"
                />

                <Form layout="horizontal"
                    onFinish={({ category, ruleName, subcatgory: subcategory }: { category: string, ruleName: string, subcatgory: string }) => {
                        if (selectedType === 'single') {
                            console.log('Submit single', category, subcategory)
                            props.updateMetadata({
                                transactionId: nextTransaction.id,
                                yyyyMm: nextTransaction.timestamp.substring(0, 7),
                                metadataKey: category,
                                metadataValue: subcategory,
                            })
                        } else if (selectedType === 'rule') {
                            console.log('Submit rule', category, ruleName, subcategory)
                            const rule = addNewMatch(props.rules, category, ruleName)
                            if (!!rule) {
                                props.updateRule(rule, undefined)
                            }
                        }
                    }}
                    labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}>
                    <Form.Item label="Category" name="category" rules={[{ required: true, message: 'Category is required' }]}>
                        <Select
                            style={{ width: 120 }}
                            options={categories.map(category => ({ value: category, label: category }))}
                        />
                    </Form.Item>
                    {selectedType === 'rule' && <Form.Item label="Match text" name="ruleName"
                        rules={[{ required: true, message: 'Match text is required' }]}
                        initialValue={nextTransaction.description.toLocaleLowerCase()}>
                        <Input placeholder="Text to match for this rule" />
                    </Form.Item>}
                    <Form.Item label="Subcatgory" name="subcatgory">
                        <Input placeholder="Subcatgory" />
                    </Form.Item>
                    <Form.Item name="submit" wrapperCol={{ span: 12, offset: 6 }}>
                        <Button type="primary" htmlType="submit">Categorise</Button>
                    </Form.Item>
                </Form>
            </div>)}
        </>}
    </>
}
